import { temAcesso } from '@/shared/auth/temAcesso'

const MeEventos = () => import('./MeEventos.vue')
const IntegrarItens = () => import('./IntegrarItens.vue')

export default {
    path: 'meeventos',
    name: 'Integracoes_MeEventos',
    component: MeEventos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-INT-ME-00')) {
            next()
        }
    },
    children: [
        {
            path: 'integrar',
            name: 'Integracoes_MeEventos_Integrar',
            component: IntegrarItens,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-INT-ME-01')) {
                    next()
                }
            }
        }
    ]
}
